<template>
  <div class="StudyHomePage" v-if="selectedStudy && tabConfig">
		<v-card
			flat
			class="tab-container"

		>
      <template>
        <v-tabs
          v-model="selectedTab"
          fixed-tabs
					hide-slider
					show-arrows
					class="tabs"
        >
          <v-tab
            v-for="tab in tabConfig"
            :key="tab.tabName"
						class="main-tab"
          >
            <v-icon left>{{tab.tabIcon}}</v-icon>
						{{tab.tabName}}
          </v-tab>
        </v-tabs>
      </template>

      <v-tabs-items v-model="selectedTab">
        <v-tab-item
          v-for="(tab) in tabConfig"
          :key="tab.tabName"
        >
				<!-- SUBTABS -->
				<v-card
						flat
						class="sub-tab-card"
					>
						<template v-if="subTabConfig.length">
							<v-toolbar
								class="sub-tab-container"
								flat
							>
								<template>
									<v-tabs
										v-model="selectedSubTab"
										fixed-tabs
										show-arrows
										class="subtabs"
									>
										<v-tab
											v-for="subTab in subTabConfig"
											class="sub-tab"
											:key=subTab.tabName
										>
										<!-- <span v-if="subTab.tabName === 'Track Recalls' && selectedStudy.recallType">{{subTab.tabName}}</span> -->
										<span v-if="subTab.tabName === 'Track Recalls' && selectedStudy.recordStudyType">{{"Track Records"}}</span>
										<span v-else >{{subTab.tabName}}</span>
										</v-tab>
									</v-tabs>
								</template>
							</v-toolbar>

							<v-tabs-items v-model="selectedSubTab">
								<v-tab-item
									v-for="subTab in subTabConfig"
									:key=subTab.tabName
									class="tab-item-element"
								>
									<v-card flat>
										<component :is="subTab.component"></component>
									</v-card>
								</v-tab-item>
							</v-tabs-items>
						</template>
						<template v-else>
							<!--
								There should be a 'component' property at the tab level if
								there are no subtabs
							-->
							<component :is="tab.component"></component>
						</template>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
export default {
	name: 'StudyHomePage',
	props: {
	},
	data: () => ({
		pageTitle: 'Study Home',
		tabConfig: null,
		/**
		 * subTabs holds an array such that the index of the array corresponds to the parent tab index. The value of that
		 * index is the index of the subtab that is currently selected.
		 * Ex., if the second visible parent tab is selected and the second subtab is selected, then subTabs[1] = 1
		 */
		subTabs: [],
		dataSelectedSubTabIndex: 0
	}),
	created () {
		window.addEventListener('keydown', (e) => {
			this.nextTab(e)
		});
	},
	/**
	 * Configure the page title of the study details. Handle the page title switching of all child components here
	 * because 1) vue-meta, when not using reactive data, will only update on mount and thus uses the page title
	 * of the last mounted component, and 2) the tab configuration object allows us to handle this easily.
	 */
	metaInfo () {
		// Setup according to vue-meta caveats page showing how to use reactive data: https://vue-meta.nuxtjs.org/guide/caveats.html#reactive-variables-in-template-functions
		const pageTitle = this.pageTitle;
		return {
			title: pageTitle
		}
	},
	async mounted () {
		this.tabConfig = this.$studyTabConfig;
		for (var i = 0; i < this.tabConfig.length; i++) {
			if (this.tabConfig[i].subTabs.length !== 0) {
				this.subTabs.push(0);
			}
		}

		// Set the page title on mount
		this.setPageTitle(this.selectedTab, this.selectedSubTab);
	},
	computed: {
		selectedStudy: function () {
			// This computed property will update the study when the selected study is
			// modified in the store
			// eslint-disable-next-line vue/no-side-effects-in-computed-properties
			return this.$store.getters.getSelectedStudy;
		},
		selectedTab: {
			get: function () {
				let tabIndex = parseInt(this.$store.getters.getCurrentStudyTabIndex);
				if (isNaN(tabIndex)) {
					tabIndex = 0;
				}
				return tabIndex;
			},
			set: function (value) {
				const tabs = { tabIndex: value, subTabIndex: 0 };
				this.$store.commit('setCurrentStudyTab', tabs);

				// Set the page title based on the current tab/subtab content
				this.setPageTitle(tabs.tabIndex, tabs.subTabIndex);
			}
		},
		selectedSubTab: {
			get: function () {
				let subTabIndex = parseInt(this.$store.getters.getCurrentStudySubTabIndex);
				if (isNaN(subTabIndex)) {
					subTabIndex = 0;
				}
				return subTabIndex;
			},
			set: function (value) {
				const tabs = { tabIndex: this.$store.getters.getCurrentStudyTabIndex, subTabIndex: value };
				this.$store.commit('setCurrentStudyTab', tabs);

				// Set the page title based on the current tab/subtab content
				this.setPageTitle(tabs.tabIndex, tabs.subTabIndex);
			}
		},
		/**
		 * Gets the sub tab configuration based on the currently selected tab.
		 * This was added because we were experiencing issues when directly using the tab.subTab array.
		 */
		subTabConfig: function () {
			return this.tabConfig[this.selectedTab].subTabs;
		}
	},
	methods: {
		setStoreCurrentTab () {
			var currentTabPos = {
				tab: parseInt(this.tab),
				subTab: this.subTabs[parseInt(this.tab)]
			};

			// Set the page title based on the current tab/subtab content
			this.setPageTitle(currentTabPos.tab, currentTabPos.subTab);

			this.$store.commit('setCurrentStudyTab', { currentTabPos });
		},
		setPageTitle (tabIndex, subTabIndex) {
			// Set the page title based on the current tab/subtab content
			if (tabIndex === undefined || tabIndex === null) {
				tabIndex = 0;
			}
			if (subTabIndex === undefined || subTabIndex === null) {
				subTabIndex = 0;
			}
			console.log('setPageTitle: tabIndex: ' + tabIndex + ', subTabIndex: ' + subTabIndex);
			if (this.tabConfig[tabIndex].subTabs.length > subTabIndex) {
				this.pageTitle = this.tabConfig[tabIndex].subTabs[subTabIndex].tabName;
			} else {
				this.pageTitle = this.tabConfig[tabIndex].tabName;
			}
			this.moveUp()
		},
		moveUp () {
			window.scrollTo(0, 0);
		},
		nextTab (e) {
			var activeEl = document.activeElement
			if (activeEl.classList.contains('main-tab')) {
				if (e.key === 'ArrowRight') {
					this.nextMainTab(activeEl, true)
				}
				if (e.key === 'ArrowLeft') {
					this.nextMainTab(activeEl, false)
				}
			}
			if (activeEl.classList.contains('sub-tab')) {
				if (e.key === 'ArrowRight') {
					this.nextSubTab(activeEl, true)
				}
				if (e.key === 'ArrowLeft') {
					this.nextSubTab(activeEl, false)
				}
			}
		},
		nextMainTab (el, next) {
			var universe = el.parentElement.querySelectorAll('.main-tab');
			var list = Array.prototype.filter.call(universe, function (item) { return item.tabIndex >= '0' });
			var index = list.indexOf(el);
			var nextEl
			next ? nextEl = list[index + 1] || list[0] : nextEl = list[index - 1] || list[list.length - 1];
			nextEl.focus()
		},
		nextSubTab (el, next) {
			var universe = el.parentElement.querySelectorAll('.sub-tab');
			var list = Array.prototype.filter.call(universe, function (item) { return item.tabIndex >= '0' });
			var index = list.indexOf(el);
			var nextEl
			next ? nextEl = list[index + 1] || list[0] : nextEl = list[index - 1] || list[list.length - 1];
			nextEl.focus()
		}
	}
}
</script>

<style>
</style>
